import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "./home.scss";

import banner1 from "../../assets/images/bannerAD1.png";
import banner2 from "../../assets/images/bannerAD2.png";
import bastet2Gif from "../../assets/images/bastet2.gif";
import bastetGif from "../../assets/images/bastet.gif";

import { Carousel } from "react-responsive-carousel";

const Banner = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
            <Carousel
                showArrows={true}
                showThumbs={false}
                infiniteLoop={true}
                autoPlay={true}
                interval={5000}
                showStatus={false}
                dynamicHeight={true}
                emulateTouch={true}
                swipeable={true}
                style={{ maxWidth: "800px", margin: "0 auto" }}
            >
                <div>
                    <img
                        src={bastetGif}
                        alt="Bastet GIF"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "500px",
                            objectFit: "contain",
                            margin: "0 auto",
                            display: "block"
                        }}
                    />
                </div>
                <div>
                    <img
                        src={banner1}
                        alt="Banner 2"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "500px",
                            objectFit: "contain",
                            margin: "0 auto",
                            display: "block"
                        }}
                    />
                </div>
                <div>
                    <img
                        src={banner2}
                        alt="Banner 3"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "500px",
                            objectFit: "contain",
                            margin: "0 auto",
                            display: "block"
                        }}
                    />
                </div>
                <div>
                    <img
                        src={bastet2Gif}
                        alt="Bastet GIF"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "500px",
                            objectFit: "contain",
                            margin: "0 auto",
                            display: "block"
                        }}
                    />
                </div>
            </Carousel>
        </div>
    );
};

export default Banner;
